<template>
  <div class="notice">
    <div class="nav">
      <h1>{{ list.title }}</h1>
    </div>
    <div class="body" v-html="list.content"></div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "notice",
  data() {
    return {
      crm: {},
      list: {},
    };
  },
  mounted() {
    if (window.localStorage.getItem("crm")) {
      let crm = JSON.parse(window.localStorage.getItem("crm"));
      this.crm = crm;
    }
    this.abue();
  },
  methods: {
    abue() {
      this.axios
        .post(
          "/crm/UserAccount/getNotice",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.list = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.nav {
  font-size: 23px;
  text-align: center;
}
.body {
  width: 60%;
  margin: 0 auto;
  margin-top: 50px;
  font-size: 18px;
}
</style>
